@if (isInitialized) {
  <oe-chart [showTotal]="showTotal" (setShowTotal)="setShowTotal($event)"
    [period]="service.historyPeriod" [title]="component.alias">
    <oe-controller-peakshaving-symmetric-chart [isOnlyChart]="true"
    [component]="component"></oe-controller-peakshaving-symmetric-chart>
  </oe-chart>
}
